class ComparedProductsElement extends HTMLElement {
    constructor() {
        super();
        this.addEventListener('click', this.handleRemoveButtonClick.bind(this));
    }

    get comparedProducts() {
        return JSON.parse(localStorage.getItem('comparedProductsAQA')) || [];
    }

    set comparedProducts(products) {
        localStorage.setItem('comparedProductsAQA', JSON.stringify(products));

        this.render();
    }

    connectedCallback() {

        this.render();

    }
  
    render() {

        if (this.comparedProducts.length > 0) {

            this.innerHTML = `
                <div>
                    <ul class="list-none compare-list">
                        ${this.comparedProducts.map(product => `
                        <li class="product_item" data-product-id="${product.id}">
                            <a href="/products/${product.handle}" class="product_heading flex gap-6 relative min-h-[40rem] md:min-h-[16rem]">
                              <img src="${product.featured_image}" alt="${product.title}" class="product_image">
                              <div class="w-3/4 flex flex-col justify-between heading_content">
                                  <h3 class="title">${product.title}</h3>
                                  <div class="price flex gap-2 items-center">
                                      ${product.compare_at_price > product.price ? `
                                          <span class="price-item font-medium mr-3">
                                            ${product.price_money}
                                          </span>
                                          <span class="compare_price">
                                              <s class="price-item font-medium">
                                                ${product.compare_at_price_money}
                                              </s>
                                          </span>
                                      ` : `
                                          <span class="price-item font-medium">
                                            ${product.price_money}
                                          </span>
                                      `}
                                  </div>
                              </div>
                            </a>
                            
                            <table>
                                <tbody>
                                    <tr>
                                        <td>Brand</td>
                                        <td>${product.vendor}</td>
                                    </tr>
                                    ${Object.entries(product.attributes || {}).map(([attribute, value]) => `
                                    <tr>
                                        <td>${attribute}</td>
                                        <td>${value}</td>
                                    </tr>
                                    `).join('')}
                                </tbody>
                            </table>
                            <div class="product_footer flex flex-col justify-center items-center">
                                <a href="/products/${product.handle}" class="button button--full-width button--secondary hover:text-white">View Product Details</a>
                                <button class="remove-button" data-product-id="${product.id}">Remove</button>
                            </div>
                        </li>
                        `)
                        .join('')}
                    </ul>
                </div>
            `;
        } else {
            this.innerHTML = `
                <div>
                    <p class="h6 text-center no-products">There are no products to compare.</p>
                </div>
            `;
        }

        this.handleEmptyCells();

    }


    handleRemoveButtonClick(event) {
        if (event.target.classList.contains('remove-button')) {
          const productId = event.target.dataset.productId;
          this.removeProduct(productId);
        }
    }
    
    removeProduct(productId) {

        this.comparedProducts = this.comparedProducts.filter(product => {
          return String(product.id) !== String(productId);
        });

        localStorage.setItem('comparedProductsAQA', JSON.stringify(this.comparedProducts));
        this.render();
    }

    handleEmptyCells() {
        const table = this.querySelectorAll('table');
        table.forEach(table => {
            const tableCells = table.querySelectorAll('td');
            tableCells.forEach(cell => {
                if (cell.innerText === '') {
                    cell.innerText = '-';
                }
            } );
        });
    }

}

customElements.define('compared-products', ComparedProductsElement);